export default __webpack_public_path__ + "static/media/KingLock.444ddd80.png";